import { useState, useEffect } from 'react';

function useMedia<T>(queries: string[], values: T[], defaultValue: T): T | null {
  const [value, setValue] = useState<T | null>(null);

  useEffect(() => {
    const mediaQueryLists = queries.map(q => window.matchMedia(q));

    const getValue = (): T => {
      const index = mediaQueryLists.findIndex(mql => mql.matches);
      return typeof values[index] !== 'undefined' ? values[index] : defaultValue;
    };

    setValue(getValue);
    const handler = () => setValue(getValue);
    mediaQueryLists.forEach(mql => mql.addListener(handler));
    return () => mediaQueryLists.forEach(mql => mql.removeListener(handler));
  }, [defaultValue, queries, values]);

  return value;
}

export default useMedia;
